import { render, staticRenderFns } from "./PromotionalItem.vue?vue&type=template&id=ec5c34d4&"
import script from "./PromotionalItem.vue?vue&type=script&lang=js&"
export * from "./PromotionalItem.vue?vue&type=script&lang=js&"
import style0 from "./PromotionalItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports